module.exports = __webpack_public_path__ + "static/sections-fd2260be635193338eb2cc2051b0f77c.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/sections.png
// module id = 2698
// module chunks = 157636680307020